<template>
  <section>
    <div class="flex items-center justify-between">
      <slot name="label">
        <FimButton
          class="flex w-full items-center justify-between hover:bg-transparent"
          no-padding
          type="raw"
          @click="collapsed = !collapsed"
        >
          <Headline tag="span" size="base" :badge="badge" class="tracking-wide">
            {{ label }}
            <template #badge="{ badge: number }">
              <span
                v-if="number"
                class="ml-1 rounded-full bg-black px-2 py-1 text-xs leading-3 text-white"
              >
                {{ number }}
              </span>
            </template>
          </Headline>

          <template #iconAfter>
            <LazyIconFielmannChevronUp v-if="collapsed" class="size-5" />
            <LazyIconFielmannChevronDown v-else key="down" class="size-5" />
          </template>
        </FimButton>
      </slot>
      <slot name="action"> </slot>
    </div>

    <div v-if="!collapsed" class="mt-2">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String as PropType<string>,
    default: '',
  },
  badge: {
    type: Number as PropType<number>,
    default: 0,
  },
})

const collapsed = ref(false)
</script>
